import React from "react";
import Icon from "../../../assets/icons/Icon";
import Error from "../UI/Error";
import { useForm } from "react-hook-form";
import Label from "../UI/Label";
import { patchAxios } from "../../Services/commonService";
import { API_RESET_PASSWORD } from "../../../utils/api/ApiConstant";
import { lowerFirstLetterUsingRegex } from "../../helper/common";

const INITIAL_DATA = {
  new: {
    isText: false,
    value: "",
  },
};

const UserResetModal = ({ rowData, handleModalHide }) => {
  console.log("🚀 ~ UserResetModal ~ rowData:", rowData);
  const {
    handleSubmit,
    register,
    reset,
    setValue,
    watch,
    formState: { errors },
    setFocus,
    setError,
    clearErrors,
  } = useForm({
    defaultValues: INITIAL_DATA,
  });

  const values = watch();

  const handleIconClick = (name) => {
    setValue(`${name}.isText`, !values[name].isText, {
      shouldDirty: false,
      shouldTouch: false,
    });
  };

  const handleFormSubit = async (values) => {
    console.log("🚀 ~ handleFormSubit ~ values:", values);

    const payload = {
      userId: rowData?.id,
      password: values?.new?.value,
    };

    const res = await patchAxios(API_RESET_PASSWORD, payload);

    if (res?.success) {
      fetchData();
      handleModalHide();
      return;
    }

    res?.errors?.forEach((element) => {
      //   const field = lowerFirstLetterUsingRegex(element?.field);
      const field = element?.field;
      if (field === "Password")
        setError("new.value", {
          type: "manual",
          message: element.message,
        });
    });
  };

  return (
    <form onSubmit={handleSubmit(handleFormSubit)}>
      <div className="row">
        <div className="col-12">
          <div className="form-group">
            <Label
              htmlFor="new-password"
              className="form-label"
              isRequired={true}
            >
              New Password
            </Label>
            <div className="password-field">
              <input
                type={values.new.isText ? "text" : "password"}
                id="new-password"
                className="form-control"
                placeholder="Enter new password"
                {...register("new.value", {
                  required: "Required",
                  minLength: {
                    value: 6,
                    message: "Minimum 6 characters required",
                  },
                  maxLength: {
                    value: 50,
                    message: "Maximum 50 characters allowed",
                  },
                })}
                tabIndex={2}
                onFocus={(e) => e.target.select()}
                autoFocus={true}
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => handleIconClick("new")}
              >
                <Icon name={values.new.isText ? "EyeClosed" : "Eye"} />
              </button>
            </div>
            {errors.new?.value && <Error>{errors.new.value.message}</Error>}
          </div>
        </div>

        <div className="col-12 mt-3">
          <div className="form-group mb-0">
            <div className="d-flex justify-content-end w-100 gap-2">
              <button
                type="button"
                className="btn btn_main btn_muted px-3 py-2"
                onClick={handleModalHide}
                tabIndex={5}
              >
                Close
              </button>
              <button
                type="submit"
                className="btn btn_main px-3 py-2"
                tabIndex={4}
              >
                Reset Password
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default UserResetModal;
